(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const syncFooter = () => document.querySelectorAll('.v5-footer-group').forEach(group => {
    if (!group.dataset.v5FooterBound) {
      group.dataset.v5FooterBound = 'true';
      group.querySelector('summary')?.addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      });
    }
    group.open = !mobile.matches;
  });
  document.addEventListener('DOMContentLoaded', syncFooter);
  document.addEventListener('shopify:section:load', syncFooter);
  mobile.addEventListener('change', syncFooter);
})();
